import type { Slide } from '../../stores/ui/types';

export const HOME_PAGE_ORDER = 3;
const ACCOUNT_PAGE_ORDER = 5;
export const ACCOUNT_RELATED_DIALOGS: Slide[] = ['account', 'loyalty_program'];

export const fullPageDialogsOrder: Map<Slide, number> = new Map([
  ['store', 1],
  ['redeem', 2],
  ['home', HOME_PAGE_ORDER],
  ['rewards', 4],
  ['account', ACCOUNT_PAGE_ORDER],
  ['loyalty_program', ACCOUNT_PAGE_ORDER],
  ['bingo', 5],
]);

export const getSlideOrder = (slideKey?: Slide | null): number => {
  if (!slideKey) {
    return HOME_PAGE_ORDER;
  }

  return fullPageDialogsOrder.get(slideKey) || HOME_PAGE_ORDER;
};
